export default "skymp5-front/02b4c2a5abadc5d27036658cc157c31c.png";